import { styled } from '@mui/material';

export const StyledContainer = styled('div')(() => ({
  width: '502px',
  height: '100vh',
  overflowY: 'auto',
  '&::-webkit-scrollbar': {
    width: '0px',
    background: 'rgba(0, 0, 0, 0)',
  },
  '&::-webkit-scrollbar-track': {
    boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.3)',
  },
  '&::-webkit-scrollbar-thumb ': {
    backgroundColor: 'darkgrey',
    borderRadius: '5px',
    outline: '1px solid slategrey',
  },
  '@media only screen and (max-width: 768px)': {
    width: '100%',
    height: 'auto',
    padding: '0 10px',
  },
  '@global': {
    '.MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
      transform: 'rotate(180deg)',
    },
  },
}));

export const StyledBorder = styled('span')(() => ({
  width: '100%',
  height: '2px',
  borderTop: '2px solid rgba(0, 0, 0, 0.12)',
}));

export const StyledDeliveryLogos = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '10px',
  '& img': {},
}));

export const StyledList = styled('ul')(() => ({
  paddingLeft: '5px',
}));
export const StyledFiles = styled('div')(() => ({
  display: 'flex',
  gap: '10px',
}));

export const StyledFile = styled('a')(() => ({
  width: '128px',
  height: '110px',
  borderRadius: '4px',
  border: '1px solid #E5E6E7',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '10px',
  color: '#7D8286',
}));

export const StyledPaymentsList = styled('ul')(() => ({
  paddingInlineStart: '15px',

  '& li': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '8px',
    lineHeight: '29px',
  },
}));
